// extracted by mini-css-extract-plugin
module.exports = {"palette":"palette--3lhhh","active":"active--2J9yI","wrap":"wrap--3dH3h","area":"area--QpuPM","tab":"tab--3ug8m","item":"item--20Lva","color":"color--2EUu3","aside":"aside--KL_Jx"};